<template>
    <div v-if="claim.visuals">
        <div
            v-for="(visual, index) in claim.visuals"
            :key="visual.id"
            class="border-bleu mb-1"
            :class="isBlack ? 'bg-gray1' : 'bg-gray2'"
        >
            <div class="col-12 px-0 visual-claim-border">
                <div class="d-flex align-items-center px-1 py-1">
                    <div
                        :key="visual.id"
                        class="image-wrapper d-flex justify-content-center align-items-center pe-1"
                    >
                        <img
                            loading="lazy"
                            :src="visual.url"
                            :alt="visual.alt"
                            class="visual-claim-img"
                        >
                    </div>
                    <div class="text-wrapper">
                        <span class="small claim-text" v-html="claim.attributes[index] ? claim.attributes[index].text : ''" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <div
            class="border-bleu"
            :class="isBlack ? 'bg-gray1' : 'bg-gray2'"
        >
            <template v-for="(attribute, index) in claim.attributes">
                <div :key="index" class="d-flex align-items-center justify-content-start">
                    <span class="small claim-text" v-html="attribute.text" />
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: "OfferClaimNew",
    props: {
        claim: {
            type: Object,
            required: true
        },
        isBlack: {
            type: Boolean,
            required: false,
            default: false
        }
    }
}
</script>

<style lang="scss" scoped>

.claim-text {
    display: grid;
    padding: 7px 7px 7px 7px;
}

.visual-claim-img {
    max-width: 60px;
    max-height: 36px;
}

.border-bleu {
    border-left: 5px solid #26B2FF
}

.image-wrapper {
    flex: 0 0 auto;
    max-width: 80px;
    width: 30%;
}

.image-wrapper img {
    height: auto;
    display: block;
}

.text-wrapper {
    flex: 1;
    overflow-wrap: break-word;
}

</style>
